// El color de cada estado de Notion, compartido por el log y el calendario.
export const ESTADO_CLASE: Record<string, string> = {
  Pendiente: 'bg-warning/15 text-warning',
  Programado: 'bg-info/15 text-info',
  Publicado: 'bg-success/15 text-success',
  Error: 'bg-danger/15 text-danger',
  Borrador: 'bg-surface-muted text-text-subtle',
};

export function fechaLinda(iso: string): string {
  const [a, m, d] = iso.split('-');
  return `${d ?? ''}/${m ?? ''}/${a ?? ''}`;
}
